import { SortableTree } from "dnd-kit-sortable-tree";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { IconButton } from "../../uikit/HeaderV3/IconButton";
import { SidebarHeader } from "../Sidebar/SidebarHeader";
import { SidebarHeaderTitle } from "../Sidebar/SidebarHeaderTitle";
import { LayersTreeItem } from "./LayersTreeItem";
import { THREE_INDENTATION_WIDTH } from "./constants";
import { useSortableTree } from "./useSortableTree";

export const Layers = () => {
  const closeSidebarView = useBuilderStore(state => state.closeSidebarView);

  const { items, handleItemsChange } = useSortableTree();

  return (
    <div className="divide-primary flex h-full w-[18rem] flex-col divide-y">
      <SidebarHeader>
        <div className="flex w-full items-center justify-between">
          <SidebarHeaderTitle>
            {t("builder_ui.layers.title")}
          </SidebarHeaderTitle>
          <IconButton
            name="24-close"
            iconSize={24}
            ariaLabel={t("close")}
            onClick={closeSidebarView}
          />
        </div>
      </SidebarHeader>

      <div className="flex size-full flex-col overflow-hidden">
        <OverlayScrollbarsComponent>
          <ul className="group/tree overflow-hidden py-2">
            <SortableTree
              items={items}
              onItemsChanged={handleItemsChange}
              TreeItemComponent={LayersTreeItem}
              indentationWidth={THREE_INDENTATION_WIDTH}
              sortableProps={{ animateLayoutChanges: () => false }}
              pointerSensorOptions={{
                activationConstraint: {
                  distance: 5,
                },
              }}
            />
          </ul>
        </OverlayScrollbarsComponent>
      </div>
    </div>
  );
};
